import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Env sanity log (no secrets): confirm backend URL wiring at build/runtime
if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.log("[Env sanity] REACT_APP_BACKEND_URL=", process.env.REACT_APP_BACKEND_URL);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
